import { useEffect } from 'react';

/*
 * Loads Front onto our own site.
 *
 * The agent id is fetched rather than hardcoded: the demo agent is seeded by
 * the backend on startup, so its id differs per environment and would silently
 * rot if pasted in here.
 *
 * This is the same `widget.js` a client would paste into their own site — no
 * privileged path, no React-only integration. If it breaks here it breaks for
 * them too, which is the point of running it on our own homepage.
 */

const SCRIPT_ID = 'frontech-front-widget';
const API = process.env.REACT_APP_BACKEND_URL;

export default function FrontWidget() {
  useEffect(() => {
    // Guard against a second mount (route changes, StrictMode double-invoke)
    // stacking two widgets on the page.
    if (document.getElementById(SCRIPT_ID)) return;
    if (!API) return;

    let cancelled = false;

    (async () => {
      let agentId = null;
      try {
        const res = await fetch(`${API}/api/demo/agent`);
        if (!res.ok) return;
        const data = await res.json();
        agentId = data.agent_id;
      } catch {
        // Backend down or unreachable. The site must still work without the
        // widget, so fail silently rather than surfacing an error to a visitor.
        return;
      }

      if (cancelled || !agentId || document.getElementById(SCRIPT_ID)) return;

      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = '/widget.js';
      script.async = true;
      script.setAttribute('data-agent-id', agentId);
      script.setAttribute('data-backend-url', API);
      script.setAttribute('data-color', '#00D67E');
      script.setAttribute('data-position', 'bottom-right');
      script.setAttribute('data-title', 'Front');
      // No auto-open. A panel that opens itself on a marketing site reads as an
      // interruption, and this one is meant to demonstrate restraint.
      script.setAttribute('data-auto-open', '0');
      document.body.appendChild(script);
    })();

    return () => { cancelled = true; };
  }, []);

  return null;
}
